import { render, staticRenderFns } from "./DownloadEvaluationList.vue?vue&type=template&id=97b656e2&scoped=true"
import script from "./DownloadEvaluationList.vue?vue&type=script&lang=js"
export * from "./DownloadEvaluationList.vue?vue&type=script&lang=js"
import style0 from "./DownloadEvaluationList.vue?vue&type=style&index=0&id=97b656e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b656e2",
  null
  
)

export default component.exports